import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, noop, map } from 'lodash';
import { compose, setDisplayName } from 'recompose';

import { Row, Column } from 'styled-components-reactive-grid';
import { GhostIndicator } from 'base-components';

import useContext from 'utils/useContext';

import CaseRequestsPanelContext from '../../../CaseRequestsPanelContext';

import DropdownCell from '../DropdownCell';
import withTireOptions from './withTireOptions';

export class TireOptionsDropdownCell extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }),
    ).isRequired,
    onChange: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    rowData: PropTypes.shape({}).isRequired,
    dependsOn: PropTypes.arrayOf(PropTypes.string),
    tireOptionsByType: PropTypes.shape({}).isRequired,
    addTireOptionsOfType: PropTypes.func.isRequired,
    isReadOnlyCase: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    value: '',
    onChange: noop,
    dependsOn: [],
  };

  componentWillMount() {
    this.registerOptions(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.registerOptions(nextProps);
  }

  getOptionsHash = options =>
    map(options, 'upstreamId')
      .join('-')
      .trim();

  registerOptions = props => {
    const { addTireOptionsOfType, rowData } = props;
    const { name: type, options, tireOptionsByType } = props;

    const rowId = get(rowData, 'id');
    const currentOptions = get(tireOptionsByType, `${rowId}.${type}`, []);

    if (
      options.length !== currentOptions.length ||
      this.getOptionsHash(options) !== this.getOptionsHash(currentOptions)
    ) {
      addTireOptionsOfType(type, options, rowId);
    }
  };

  render() {
    const { options, onChange, isLoading, rowData } = this.props;

    if (isLoading && !rowData.readOnly) {
      return (
        <Row>
          <Column modifiers="col">
            <GhostIndicator />
          </Column>
        </Row>
      );
    }

    return (
      <DropdownCell
        {...{
          ...this.props,
          options,
          onChange,
          autoSelectSingleOption: true,
        }}
      />
    );
  }
}

export default compose(
  setDisplayName('TireOptionsDropdownCell'),
  useContext(CaseRequestsPanelContext),
  withTireOptions,
)(TireOptionsDropdownCell);



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestLines/BaseRequestLinesTable/TireOptionsDropdownCell/index.js